import { AlarmComment } from '../../shared/models/alarm.model'
import dayjs from 'dayjs'
import {
  formatUnixMillisecondsDuration,
  getDiffTimeInMs,
} from '../../utils/utils'
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import Avatar from '../../components/common/Avatar'
import React from 'react'

interface Props {
  comment?: AlarmComment
}

const AlarmCommentDisplay = ({ comment }: Props) => {
  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props} placement={'right'}>
      {comment?.createdAt ? dayjs(comment.createdAt).format() : 'unknown time'}
    </Tooltip>
  )
  if (!comment) {
    return null
  }

  if (comment.type === 'USER') {
    return (
      <>
        <Row className={'mt-3'}>
          <Col className={'d-flex flex-row mx-auto'}>
            <Avatar name={comment.details.name} />
            <div className={'ms-2'}>
              <div className={'d-flex flex-column mx-auto'}>
                <div>
                  <span className={'fw-bold'}>{comment.details.name}</span>

                  {comment.createdAt && (
                    <OverlayTrigger
                      placement="left"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <span className={'fw-light fs-9 ms-3'}>
                        {formatUnixMillisecondsDuration(
                          getDiffTimeInMs(comment.createdAt)
                        )}
                      </span>
                    </OverlayTrigger>
                  )}
                </div>
                <div className={'fs-9'}>{comment.details.email}</div>
              </div>
            </div>
          </Col>

          <div>{comment.details.text}</div>
        </Row>
      </>
    )
  } else {
    return (
      <Row className={'mb-3'}>
        <Col className={'d-flex flex-row'} md={{ offset: 1 }}>
          <div className={'fw-bold fs-9 me-3 cursor-pointer'}>
            {comment.details.text}
          </div>
          {comment.createdAt && (
            <OverlayTrigger
              placement="left"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <div className={'fw-light fs-9'}>
                {formatUnixMillisecondsDuration(
                  getDiffTimeInMs(comment.createdAt)
                )}
              </div>
            </OverlayTrigger>
          )}
        </Col>
      </Row>
    )
  }
}

export default AlarmCommentDisplay
